module.exports = __webpack_public_path__ + "img/home-dsh.924b9857.svg";